import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { DeletedPlanningModel } from '../business-entities/delete-planning-model';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class DeletedPlanningDataService {

  constructor(private dataProvider : DataService) { }

  async getDeletedPlanningList(data):Promise<GenericResponse<Array<DeletedPlanningModel>>>{
    return this.dataProvider.Post<GenericResponse<Array<DeletedPlanningModel>>>(Urls.GetDeletedPlanning,data).toPromise();
  }

}